import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class FilterService {

  constructor() { }

  setFilter(list) {
    const tecimento = list.map(item => {
      if (item.TECIMENTO) {
        return item.TECIMENTO.toLowerCase()
      }
    }).filter(function(item, pos, self) {
      if (item.length > 0)
        return self.indexOf(item) == pos;
    });
    const base = list.map(item => {
      if (item.BASE) {
        return item.BASE.toLowerCase()
      }
    }).filter(function(item, pos, self) {
      if (item.length > 0)
        return self.indexOf(item) == pos;
    });
    const grupo = list.map(item => {
      if (item.GRUPO) {
        return item.GRUPO.toLowerCase()
      }
    }).filter(function(item, pos, self) {
      if (item.length > 0)
        return self.indexOf(item) == pos;
    });
    const aspecto = list.map(item => {
      if (item.SGRUPO) {
        return item.SGRUPO.toLowerCase()
      }
    }).filter(function(item, pos, self) {
      if (item.length > 0)
        return self.indexOf(item) == pos;
    });
    const cores = list.map(item => {
      if (item.GRUPO_CORES) {
        return item.GRUPO_CORES.toLowerCase()
      }
    }).filter(function(item, pos, self) {
      if (item.length > 0)
        return self.indexOf(item) == pos;
    });
    const composicao = list.map(item => {
      let arr = [];
      if (item.CMP1 != null)
        arr.push(item.CMP1.toLowerCase());
      if (item.CMP2 != null)
        arr.push(item.CMP2.toLowerCase());
      if (item.CMP3 != null)
        arr.push(item.CMP3.toLowerCase());
      if (item.CMP4 != null)
        arr.push(item.CMP4.toLowerCase());
      if (item.CMP5 != null)
        arr.push(item.CMP5.toLowerCase());
      if (item.CMP6 != null)
        arr.push(item.CMP6.toLowerCase());
      return arr;
    }).reduce(function(prev, curr) {
      return prev.concat(curr);
    }).filter(function(item, pos, self) {
      if (item.length > 0)
        return self.indexOf(item) == pos;
    });
    const motivo = list.map(item => {
      if (item.MOTIVO_PADRAO) {
        return item.MOTIVO_PADRAO.toLowerCase()
      }
    }).filter(function(item, pos, self) {
      if (item && item.length > 0)
        return self.indexOf(item) == pos;
    });
    const detalhe = list.map(item => {
      if (item.MOTIVO_DETALHE) {
        return item.MOTIVO_DETALHE.toLowerCase()
      }
    }).filter(function(item, pos, self) {
      if (item && item.length > 0)
        return self.indexOf(item) == pos;
    });

    let filters = [
      {
        name: 'Tecimento',
        options: tecimento.sort(),
        path: ['TECIMENTO'],
        selected: []
      },
      {
        name: 'Base',
        options: base.sort(),
        path: ['BASE'],
        selected: []
      },
      {
        name: 'Grupo',
        options: grupo.sort(),
        path: ['GRUPO'],
        selected: []
      },
      {
        name: 'Aspecto',
        options: aspecto.sort(),
        path: ['SGRUPO'],
        selected: []
      },
      {
        name: 'Grupo de Cores',
        options: cores.sort(),
        path: ['GRUPO_CORES'],
        selected: []
      },
      {
        name: 'Composição',
        options: composicao.sort(),
        path: ['CMP1','CMP2','CMP3','CMP4','CMP5','CMP6'],
        selected: []
      },
      {
        name: 'Motivos',
        options: motivo.sort(),
        path: ['MOTIVO_PADRAO'],
        selected: []
      },
      {
        name: 'Detalhes',
        options: detalhe.sort(),
        path: ['MOTIVO_DETALHE'],
        selected: []
      }
    ];
    return filters;
  }
}
